# Grafy pro spínání
# version: 1.3

class SwitchingChart
    ###
    Třída pro vykreslení a ovládání grafu pro zadání spínacího schematu.
    ###

    constructor: (@params={}) ->
        ###
        Inicializace grafu a základních elementů.
        ###
        self = @

        # default parametry
        _.defaults(@params, {
            # povinné:
            id: null,
            data: null,
            chart_place: null,
            values_place: null,
            # nepovinné:
            rates: null,
            readonly: false,
            width: 600,
            height: 75,
            svg_class: "chart",
            slider_edge_width: 4,
            slider_min_width: 16,
            slider_min_margin: 4,
        })

        margin = {left: 20, top: 0, right: 20, bottom: 25}

        chart_width = @params.width - margin.left - margin.right
        @chart_height = @params.height - margin.top - margin.bottom

        # definice osy x
        @x_min = moment({hour: 0, minute: 0})
        @x_max = moment({hour: 0, minute: 0}).add('days', 1)

        @x_scale = d3.time.scale()
            .range([0, chart_width])
            .domain([@x_min, @x_max])

        x_axis = d3.svg.axis()
            .scale(@x_scale)
            .orient("bottom")
            .tickFormat(d3.time.format("%H:%M"))
            .tickSubdivide(2)
            .tickSize(6, 3, 6)
            .ticks(d3.time.hours, 3)

        # připravíme data
        @data = @params.data
        @preprocess_data()

        # vyčistíme místo pro graf a tabulku hodnot
        $(@params.chart_place).empty()
        @values_place = $(@params.values_place)
        @values_place.empty()
        @note_place = $(@params.note_place)
        @note_place.empty()

        # vykreslíme základní elementy grafu
        svg = d3.select(@params.chart_place).append("svg")
            .attr("class", @params.svg_class)
            .attr("width", @params.width)
            .attr("height", @params.height)

        @chart = svg.append("g")
            .attr("transform", "translate(#{margin.left}, #{margin.top})")
            .append("svg")
                .attr("width", chart_width)
                .attr("height", @chart_height)

        svg.append("g")
            .attr("class", "axis-layer")
            .attr("transform", "translate(#{margin.left}, #{(margin.top + @chart_height)})")
            .call(x_axis)

        # definice funkcí reagujících na Drag

        dragmove_start = (d) ->
            ###
            Drag počátečního bodu slideru.
            ###
            # Pokud jsme v read-only rezimu, tak koncime
            if self.params.readonly
                return
            # zjistíme id slideru
            slider = d3.select(this)[0][0].parentNode
            id = slider.getAttribute("data-slider-id")

            # výpočet souřadnice pro počátek slideru
            if slider.previousSibling is null
                min_start = 0
            else
                min_start = slider.previousSibling.children[0].__data__.end + self.params.slider_min_margin
            d.start = d3.max([min_start, d3.min([d3.event.x, d.end - self.params.slider_min_width])])

            # překreslení slideru
            self.chart.select(".slider-#{id}.slider-start")
                .attr("x", d.start)
            self.chart.select(".slider-#{id}.slider-body")
                .attr("x", d.start)
                .attr("width", d.end - d.start)

            # update hodnot
            self.update_times_in_data()
            self.draw_values_table()

        dragmove_end = (d) ->
            ###
            Drag koncového bodu slideru.
            ###
            # Pokud jsme v read-only rezimu, tak koncime
            if self.params.readonly
                return
            # zjistíme id slideru
            slider = d3.select(this)[0][0].parentNode
            id = slider.getAttribute("data-slider-id")

            # výpočet souřadnice pro konec slideru
            if slider.nextSibling is null
                max_end = chart_width
            else
                max_end = slider.nextSibling.children[0].__data__.start - self.params.slider_min_margin

            d.end = d3.min([max_end, d3.max([d3.event.x, d.start + self.params.slider_min_width])])

            # překreslení slideru
            self.chart.select(".slider-#{id}.slider-end")
                .attr("x", d.end - self.params.slider_edge_width)
            self.chart.select(".slider-#{id}.slider-body")
                .attr("width", d.end - d.start)

            # update hodnot
            self.update_times_in_data()
            self.draw_values_table()

        dragmove_body = (d) ->
            ###
            Drag těla slideru.
            ###
            # Pokud jsme v read-only rezimu, tak koncime
            if self.params.readonly
                return
            # zjistíme id slideru
            slider = d3.select(this)[0][0].parentNode
            id = slider.getAttribute("data-slider-id")

            # výpočet souřadnic pro počátek a konec slideru
            width = d.end - d.start

            if slider.previousSibling is null
                min_start = 0
            else
                min_start = slider.previousSibling.children[0].__data__.end + self.params.slider_min_margin

            if slider.nextSibling is null
                max_start = chart_width - width
            else
                max_start = slider.nextSibling.children[0].__data__.start - self.params.slider_min_margin - width

            d.start = d3.max([min_start, d3.min([max_start, d3.event.x])])
            d.end = d.start + width

            # překreslení slideru
            self.chart.select(".slider-#{id}.slider-start")
                .attr("x", d.start)
            self.chart.select(".slider-#{id}.slider-end")
                .attr("x", d.end - self.params.slider_edge_width)
            self.chart.select(".slider-#{id}.slider-body")
                .attr("x", d.start)

            # update hodnot
            self.update_times_in_data()
            self.draw_values_table()

        # definice událostí D3 Drag

        @drag_start = d3.behavior.drag()
            .on("drag", dragmove_start)

        @drag_end = d3.behavior.drag()
            .on("drag", dragmove_end)

        @drag_body = d3.behavior.drag()
            .origin((d) -> {x: d3.select(this).attr("x")})
            .on("drag", dragmove_body)

        # vykreslení grafu
        @draw()

    draw: ->
        ###
        Vykreslí / překreslí graf a tabulku hodnot.
        ###
        @draw_sliders()
        @draw_values_table()
        @draw_note()

    preprocess_data: ->
        ###
        Parsuje vstupní data.
        1. nahradí textové reprezentace času moment.js objekty
        2. doplní výchozí pozice pro slidery
        ###
        id = 0
        for item in @data
            item.start_time = moment(item.start_time, "HH:mm")
            item.end_time = moment(item.end_time, "HH:mm")
            # pokud je end_time 00:00, pak je to další den
            if item.end_time.hour() == 0 and item.end_time.minute() == 0
                item.end_time.add('days', 1)
            item.id = id

            if _.has(item, 'level')
                level = item.level
            else
                if @params.rates
                    level = @params.rates[0].id
                else
                    level = 0
            item.level = parseInt(level)

            id += 1
        @update_positions_in_data()
        @sort_data()

    update_positions_in_data: ->
        ###
        Nastaví pozice sliderů v datech podle datumů.
        ###
        for item in @data
            item.start = @x_scale(item.start_time)
            item.end = @x_scale(item.end_time)

    update_times_in_data: ->
        ###
        Nastaví datumy v datech podle pozic sliderů z grafu.
        ###
        for item in @data
            item.start_time = moment(@x_scale.invert(item.start))
            item.end_time = moment(@x_scale.invert(item.end))

    sort_data: ->
        ###
        Setřídí data podle start_time.
        ###
        @data = _.sortBy(@data, (item) -> item.start_time)

    draw_sliders: ->
        ###
        Vykreslí / překreslí slidery.
        ###
        # smažeme slidery
        @chart.selectAll("g.slider-group").remove()
        maybe_disabled = ''
        if @params.readonly
            maybe_disabled = "disabled"

        # vykreslíme slidery
        for item in @data


            if @params.rates
                level_class = _.find(@params.rates, (rate)-> rate.id == item.level).id
            else
                level_class = "0"

            slider = @chart.append("g")
                .attr("class", "slider-group level-#{level_class}")
                .attr("data-slider-id", item.id)

            slider.append("rect")
                .datum(item)
                .attr("class", "slider-#{item.id} slider-body #{maybe_disabled}")
                .attr("width", (d) -> d.end - d.start)
                .attr("height", @chart_height)
                .attr("x", (d) -> d.start)
                .call(@drag_body)

            slider.append("rect")
                .datum(item)
                .attr("class", "slider-#{item.id} slider-start #{maybe_disabled}")
                .attr("width", @params.slider_edge_width)
                .attr("height", @chart_height)
                .attr("x", (d) -> d.start)
                .call(@drag_start)

            slider.append("rect")
                .datum(item)
                .attr("class", "slider-#{item.id} slider-end #{maybe_disabled}")
                .attr("width", @params.slider_edge_width)
                .attr("height", @chart_height)
                .attr("x", (d) => d.end - @params.slider_edge_width)
                .call(@drag_end)

    draw_values_table: ->
        ###
        Vykreslí / překreslí tabulku s hodnotami.
        ###
        out = "<table class='table-switching-inputs'>"
        # inputy s hodnotami
        for item in @data
            start = item.start_time.format("HH:mm")
            end = item.end_time.format("HH:mm")
            maybe_disabled = ''
            if @params.readonly
                maybe_disabled = "disabled='disabled'"

            if @params.rates
                level_class = _.find(@params.rates, (rate)-> rate.id == item.level).id
            else
                level_class = "0"

            out += "
            <tr class='level-#{level_class}'>
                <td><input #{maybe_disabled} type='text' value='#{start}' class='form-control input-start' data-chart_id='#{@params.id}' data-switch_id='#{item.id}'></td>
                <td>—</td>
                <td><input #{maybe_disabled} type='text' value='#{end}' class='form-control input-end' data-chart_id='#{@params.id}' data-switch_id='#{item.id}'></td>"

            out += "<td>"
            if @params.rates
                if @params.readonly
                    out += "<input #{maybe_disabled} type='text' value='#{@params.rates[item.level].label}' class='form-control rate-label' />"
                else
                    out += "<select #{maybe_disabled} name='switch-#{@params.id}-#{item.id}' data-chart_id='#{@params.id}' data-switch_id='#{item.id}' class='form-control'>"
                    for level in @params.rates
                        out += "<option value='#{level.id}' #{if item.level == level.id then "selected='selected'" else ""}>#{level.label}</option>"
                    out += "</select>"
            out += "<td>"
            if not @params.readonly
                out += "<td> &nbsp; <button class='btn btn-default remove-switch' data-chart_id='#{@params.id}' data-switch_id='#{item.id}'><span class='icon-trash'></span></button></td>"
            out += "<td><div id='validation-#{@params.id}-#{item.id}'></div></td>
            </tr>"
        # tlačítko add
        if not @params.readonly
            out += "<tr><td colspan='4'></td><td> &nbsp; <button class='btn btn-primary add-switch' data-chart_id='#{@params.id}'><span class='icon-plus'></span></button></td></tr>"
        out += "</table>"
        @values_place.html(out)

    draw_note: ->
        ###
        Vykreslí / překreslí poznamku.
        ###
        out = "<div class='note'>"
        if _.has(@params, 'note') and @params.note? and not(_.isUndefined(@params.note))
            out = "#{@params.note}"
        out += "</div>"
        @note_place.html(out)

class SwitchingController
    ###
    Třída pro ovládání skupiny grafů SwitchingChart.
    ###

    constructor: (@params={}) ->
        ###
        Inicializace ovladače grafů.
        ###
        self = @
        @charts = {}

        # default parametry
        _.defaults(@params, {
            # povinné:
            place: null,
            days: null,
            # nepovinné:
            rates: null,
            readonly: false,
            chart_params: {},
            alert_callback: (msg) -> alert(msg)
            validation_callback: (chart_id, switch_id, msg) ->
                $("#validation-#{chart_id}-#{switch_id}").addClass('alert alert-danger').text(msg)
        })

        $place = $(@params.place)

        # vyčistíme plochu
        $place.empty()

        # vygenerujeme grafy
        last_data = null
        for day in @params.days
            chart_id = @params.days.indexOf(day)
            # vygenerujeme html layout pro graf a tabulku hodnot
            @append_chart_layout(chart_id, day.title)

            # parametry grafu
            params =
                id: chart_id
                rates: @params.rates
                readonly: @params.readonly
                data: day.data
                chart_place: @get_place_for_chart(chart_id)
                values_place: @get_place_for_values(chart_id)
                note_place: @get_place_for_note(chart_id)
                title: day.title

            if _.has(day, 'weekday')
                params.weekday = day.weekday

            if _.has(day, 'name')
                params.name = day.name

            if _.has(day, 'note')
                params.note = day.note

            _.defaults(params, @params.chart_params)
            chart = new SwitchingChart(params)

            # nastavení "jako předchozí den"
            if _.isEqual(day.data, last_data)
                chart.same_as_previous = true
                $checkbox = $place.find("input.checkbox-same[data-chart_id='#{chart_id}']")
                $checkbox.attr("checked", true)
                $checkbox.closest(".panel").children(".panel-body").hide()
            else
                chart.same_as_previous = false
            last_data = day.data

            # vložíme graf do registru grafů
            @charts[chart.params.id] = chart

        # binding JS eventů

        if not params.readonly

            # click na button remove
            $place.on("click", "button.remove-switch", (event) ->
                event.preventDefault()
                $this = $(this)
                chart_id = parseInt($this.attr('data-chart_id'))
                switch_id = parseInt($this.attr('data-switch_id'))
                self.remove_switch(chart_id, switch_id)
            )

            # zmena selectu s urovni tarifu
            $place.on("change", "select", (event) ->
                $this = $(this)
                chart_id = parseInt($this.attr('data-chart_id'))
                switch_id = parseInt($this.attr('data-switch_id'))
                self.set_switch_level(chart_id, switch_id, parseInt($this.val()))
            )

            # click na button add
            $place.on("click", "button.add-switch", (event) ->
                event.preventDefault()
                $this = $(this)
                chart_id = parseInt($this.attr('data-chart_id'))
                self.add_switch(chart_id)
            )

            # change checkboxu "jako předchozí den"
            $place.on("change", "input.checkbox-same", (event) ->
                $this = $(this)
                chart_id = parseInt($this.attr('data-chart_id'))
                if $this.prop("checked")
                    self.set_same_as_previous(chart_id)
                    $this.closest(".panel").children(".panel-body").slideUp()
                else
                    self.unset_same_as_previous(chart_id)
                    $this.closest(".panel").children(".panel-body").slideDown()
            )

            # klávesa Enter nebo Tab na input pro start_time
            $place.on("keydown", "input.input-start", (event) ->
                if event.which == 13 or event.which == 9
                    event.preventDefault()
                    $this = $(this)
                    chart_id = parseInt($this.attr('data-chart_id'))
                    switch_id = parseInt($this.attr('data-switch_id'))
                    # self.event_log(event)

                    # parsování a validace hodnoty
                    time = self.parse_start_time_input($this.val())
                    if not time.isValid()
                        $this.parent().addClass("has-error")
                        self.params.validation_callback(chart_id, switch_id, gettext("Expecting hours:minute time format e.g. 21:35"))
                        return false

                    # nastavení hodnoty
                    success = self.set_switch_start_time(chart_id, switch_id, time)

                    # předáme focus
                    if success
                        # musíme znovu najít $this protože jsme přegenerovali
                        # elementy v tabulce
                        $this = $place.find("input.input-start[data-chart_id='#{chart_id}'][data-switch_id='#{switch_id}']")
                        $next = $place.find("input:eq(#{($place.find("input").index($this) + 1)})")
                        if $next.length == 0
                            $this.focus()
                        else
                            $next.focus()
                    else
                        $this.parent().addClass("has-error")
            )

            # klávesa Enter nebo Tab na input pro end_time
            $place.on("keydown", "input.input-end", (event) ->
                if event.which == 13 or event.which == 9
                    event.preventDefault()
                    $this = $(this)
                    chart_id = parseInt($this.attr('data-chart_id'))
                    switch_id = parseInt($this.attr('data-switch_id'))
                    # self.event_log(event)

                    # parsování a validace hodnoty
                    time = self.parse_end_time_input($this.val())
                    if not time.isValid()
                        $this.parent().addClass("has-error")
                        self.params.validation_callback(chart_id, switch_id, gettext("Expecting hours:minute time format e.g. 21:35"))
                        return false

                    # nastavení hodnoty
                    success = self.set_switch_end_time(chart_id, switch_id, time)

                    # předáme focus
                    if success
                        # musíme znovu najít $this protože jsme přegenerovali
                        # elementy v tabulce
                        $this = $place.find("input.input-end[data-chart_id='#{chart_id}'][data-switch_id='#{switch_id}']")
                        $next = $place.find("input:eq(#{($place.find("input").index($this) + 1)})")
                        if $next.length == 0
                            $this.focus()
                        else
                            $next.focus()
                    else
                        $this.parent().addClass("has-error")
            )

            # ztráta focusu na input pro start_time
            $place.on("focusout", "input.input-start", (event) ->
                $this = $(this)
                chart_id = parseInt($this.attr('data-chart_id'))
                switch_id = parseInt($this.attr('data-switch_id'))
                # self.event_log(event)

                # parsování a validace hodnoty
                time = self.parse_start_time_input($this.val())
                if not time.isValid()
                    # $this.parent().addClass("has-error")
                    self.params.validation_callback(chart_id, switch_id, gettext("Expecting hours:minute time format e.g. 21:35"))
                    # vrátíme focus
                    # $this.focus()
                    return false

                # nastavení hodnoty
                success = self.set_switch_start_time(chart_id, switch_id, time)

                # pokud se nezdařilo nastavení hodnoty, vrátíme focus
                if not success
                    $this.parent().addClass("has-error")
                    $this.focus()
            )

            # ztráta focusu na input pro end_time
            $place.on("focusout", "input.input-end", (event) ->
                $this = $(this)
                chart_id = parseInt($this.attr('data-chart_id'))
                switch_id = parseInt($this.attr('data-switch_id'))
                # self.event_log(event)

                # parsování a validace hodnoty
                time = self.parse_end_time_input($this.val())
                if not time.isValid()
                    $this.parent().addClass("has-error")
                    # vrátíme focus
                    # $this.focus()
                    self.params.validation_callback(chart_id, switch_id, gettext("Expecting hours:minute time format e.g. 21:35"))
                    return false

                # nastavení hodnoty
                success = self.set_switch_end_time(chart_id, switch_id, time)

                # pokud se nezdařilo nastavení hodnoty, vrátíme focus
                if not success
                    $this.parent().addClass("has-error")
                    $this.focus()
            )

    event_log: (event)->
        console.log "Event: " + event.type + " " + event.currentTarget.className

    parse_start_time_input: (value) ->
        ###
        Parsuje hodnotu z inputu start_time na moment.js objekt.
        ###
        if _.indexOf(["24:00", "24:0", "24:", "24"], value) != -1
            return moment({hour: 0, minute: 0}).add('days', 1)
        else
            return moment(value, "HH:mm")

    parse_end_time_input: (value) ->
        ###
        Parsuje hodnotu z inputu end_time na moment.js objekt.
        ###
        if _.indexOf(["24:00", "24:0", "24:", "24"], value) != -1
            return moment({hour: 0, minute: 0}).add('days', 1)
        else
            time = moment(value, "HH:mm")
            if time.hours() == 0 and time.minutes() == 0
                time.add('days', 1)
            return time

    ###
    Zjisti, jestli cas zadany v inputu neni uvnitr nektereho z uz definovanych casovych intervalu v ramci dne
    ###
    is_colliding: (chart_id, switch_id, time) ->
        chart = @charts[chart_id]

        try
            moment.isMoment(time) and _.isObject(chart) and not _.isEmpty(chart)
        catch error
            console.error "time is not a momentjs instance or chart is empty/not an object"
            return true

        collisions = _.find(chart.data, (period) ->
            period.id != switch_id and # musim vyloucit z porovnavani sebe sama
            time.isAfter(period.start_time) and
            time.isBefore(period.end_time)
        )
        # Pokud _.find neco najde, collisions nebudou undefined a is_coliding vrati true
        return not _.isUndefined(collisions)

    set_switch_start_time: (chart_id, switch_id, time) ->
        ###
        Nastaví start_time pro switch.
        ###
        chart = @charts[chart_id]
        sw = _.find(chart.data, (item) -> item.id is switch_id)
        if time >= sw.end_time
            @params.validation_callback(chart_id, switch_id, gettext("Rate validity start time must not be later than it's end time."))
            return false
        else if @is_colliding(chart_id, switch_id, time)
            @params.validation_callback(chart_id, switch_id, gettext("Rate validity start time must not be inside already existing validity interval."))
            return false
        else
            sw.start_time = time
            chart.update_positions_in_data()
            chart.sort_data()
            chart.draw()
            return true

    set_switch_end_time: (chart_id, switch_id, time) ->
        ###
        Nastaví end_time pro switch.
        ###
        chart = @charts[chart_id]
        sw = _.find(chart.data, (item) -> item.id is switch_id)
        if time <= sw.start_time
            @params.validation_callback(chart_id, switch_id, gettext("Rate validity end time must not be sooner than it's start time."))
            return false
        else if @is_colliding(chart_id, switch_id, time)
            @params.validation_callback(chart_id, switch_id, gettext("Rate validity end time must not be inside already existing validity interval."))
            return false
        else
            sw.end_time = time
            chart.update_positions_in_data()
            chart.draw()
            return true

    set_switch_level: (chart_id, switch_id, level) ->
        ###
        Nastaví level pro switch.
        ###

        chart = @charts[chart_id]
        sw = _.find(chart.data, (item) -> item.id is switch_id)
        sw.level = level
        chart.update_positions_in_data()
        chart.draw()
        return true

    remove_switch: (chart_id, switch_id) ->
        ###
        Smaže switch.
        ###
        chart = @charts[chart_id]
        chart.data = _.filter(chart.data, (item) -> item.id != switch_id)
        chart.draw()

    add_switch: (chart_id) ->
        ###
        Přidá switch.
        ###
        chart = @charts[chart_id]

        # zjistíme id a maximální čas z existujících dat
        if chart.data.length > 0
            item_id = _.max(chart.data, (item) -> item.id).id + 1
            max_time = _.max(chart.data, (item) -> item.end_time).end_time
        else
            item_id = 0
            max_time = chart.x_min

        # potřebujeme alespoň dvě minuty na konci grafu
        if moment(max_time).add('minutes', 1) > chart.x_max
            @params.alert_callback(gettext("At least 2 minutes before end of the day need to be left free."))
            return null

        # sestavíme switch
        item =
            id: item_id
            start_time: moment(max_time).add('minutes', 30)
            end_time: moment(max_time).add('minutes', 90)
            level: 0

        if item.start_time > chart.x_max
            item.start_time = moment(chart.x_max).subtract('minutes', 1)
        if item.end_time > chart.x_max
            item.end_time = chart.x_max

        # přidáme switch do dat a překreslíme graf
        chart.data.push(item)
        chart.update_positions_in_data()
        chart.draw()

    append_chart_layout: (chart_id, title) ->
        ###
        Do elementu @params.place přidá html layout pro graf.
        ###
        maybe_hidden = ''
        if @params.readonly
            maybe_hidden = "hidden='hidden'"

        out = "<div class='panel panel-default'>
            <div class='panel-heading'>"
        if chart_id == 0
            out += "<h3 class='panel-title'>#{title}</h3>"
        else
            out += "<h3 class='panel-title pull-left'>#{title}</h3>&nbsp; &nbsp; &nbsp; "
            out += "<input #{maybe_hidden} type='checkbox' class='checkbox-same' data-chart_id='#{chart_id}'>&nbsp; "
            out += "<span>" + gettext("Same as the day before") + "</span>";

        out += "</div>
            <div class='panel-body'>
                <div id='#{@get_place_for_chart(chart_id).slice(1)}'></div>
                <div id='#{@get_place_for_values(chart_id).slice(1)}'></div>
                <div id='#{@get_place_for_note(chart_id).slice(1)}'></div>
            </div>
        </div>"
        $(@params.place).append(out)

    get_place_for_chart: (chart_id) ->
        ###
        Vrátí ID html elementu pro vykreslení grafu.
        ###
        return "#{@params.place}_chart_#{chart_id}"

    get_place_for_values: (chart_id) ->
        ###
        Vrátí ID html elementu pro vykreslení tabulky hodnot.
        ###
        return "#{@params.place}_values_#{chart_id}"

    get_place_for_note: (chart_id) ->
        ###
        Vrátí ID html elementu pro vykreslení poznamky.
        ###
        return "#{@params.place}_note_#{chart_id}"

    set_same_as_previous: (chart_id) ->
        ###
        Nastaví graf na "stejný jako předchozí den".
        ###
        @charts[chart_id].same_as_previous = true

    unset_same_as_previous: (chart_id) ->
        ###
        Zruší nastavení grafu na "stejný jako předchozí den".
        ###
        @copy_data_for_same_charts()
        @charts[chart_id].same_as_previous = false
        @charts[chart_id].draw()

    copy_data_for_same_charts: ->
        ###
        Nakopíruje data pro grafy nastavené na "stejný jako předchozí den".
        ###
        last_data = null
        for chart in _.values(@charts)
            if chart.same_as_previous
                chart.data = []
                for item in last_data
                    # deep copy !
                    chart.data.push($.extend(true, {}, item))
            last_data = chart.data

    get_switching_data: ->
        ###
        Vrátí data spínání pro všechny dny.
        ###
        @copy_data_for_same_charts()
        days = []
        for chart in _.values(@charts)
            data = []
            for item in chart.data
                data.push({
                    start_time: item.start_time.format("HH:mm"),
                    end_time: item.end_time.format("HH:mm"),
                    level: item.level
                })
            day =
                data: data
                title: chart.params.title

            if _.has(chart.params, 'weekday')
                day.weekday = chart.params.weekday

            if _.has(chart.params, 'name')
                day.name = chart.params.name

            days.push(day)
        return {days: days}

    close: ->
        $place = $(@params.place)
        $place.off()
        $place.empty()


# $ ->
#     # NOTE: Takový konfigurační JSON je třeba vygenerovat. Je možné zadat
#     # nepovinné parametry (viz. konstruktor třídy SwitchingController).
#     # V parametru chart_params lze zadat JSON s nepovinnými parametry pro
#     # grafy (viz. konstruktor třídy SwitchingChart).
#     config = {
#         place: "#switching_place",
#         rates: [
#             {
#                 id: "XX",
#                 label: "Tarifní hladina XX"
#             }
#         ],
#         days: [
#             {
#                 weekday: 0,
#                 title: "pondělí",
#                 data: [
#                     {start_time: "00:00", end_time: "01:00"},
#                     {start_time: "05:00", end_time: "10:00"},
#                     {start_time: "13:00", end_time: "16:00"},
#                     {start_time: "20:00", end_time: "23:00"},
#                 ],
#             },
#             {
#                 weekday: 1,
#                 title: "úterý",
#                 data: [
#                     {start_time: "02:00", end_time: "08:00"},
#                     {start_time: "12:25", end_time: "14:55"},
#                     {start_time: "19:00", end_time: "22:30"},
#                 ],
#             },
#             {
#                 weekday: 2,
#                 title: "středa",
#                 data: [
#                     {start_time: "02:00", end_time: "08:00"},
#                     {start_time: "12:25", end_time: "14:55"},
#                     {start_time: "19:00", end_time: "22:30"},
#                 ],
#             },
#             {
#                 weekday: 3,
#                 title: "čtvrtek",
#                 data: [
#                     {start_time: "02:00", end_time: "08:00"},
#                     {start_time: "12:25", end_time: "14:55"},
#                     {start_time: "19:00", end_time: "22:30"},
#                 ],
#             },
#             {
#                 weekday: 4,
#                 title: "pátek",
#                 data: [
#                     {start_time: "02:00", end_time: "08:00"},
#                     {start_time: "12:25", end_time: "14:55"},
#                     {start_time: "19:00", end_time: "22:30"},
#                 ],
#             },
#             {
#                 weekday: 5,
#                 title: "sobota",
#                 data: [
#                     {start_time: "00:00", end_time: "08:00"},
#                     {start_time: "12:00", end_time: "15:00"},
#                     {start_time: "20:00", end_time: "21:00"},
#                     {start_time: "22:00", end_time: "00:00"},
#                 ],
#             },
#             {
#                 weekday: 6,
#                 title: "neděle",
#                 data: [
#                     {start_time: "00:00", end_time: "08:00"},
#                     {start_time: "12:00", end_time: "15:00"},
#                     {start_time: "20:00", end_time: "21:00"},
#                     {start_time: "22:00", end_time: "00:00"},
#                 ],
#             },
#         ],
#     }
#
#     sc = new SwitchingController(config)
#
#     # NOTE: Takto získáme data spínání.
#     # sc.get_switching_data()
